/**
 *
 * @param {string} mobileNumber  eg: 04XX XXX XXX
 * @returns string eg:  04XXXXXXXX
 */

export const formatMobileNumberInput = (mobileNumber) => {
  if (mobileNumber) {
    const digits = mobileNumber.replace(/\D/g, '').substring(0, 10);
    return digits.replace(/(\d{4})(\d{3})(\d{3})/, '$1 $2 $3');
  }
  return '';
};

/**
 *
 * @param {string} mobileNumber eg. 04XX XXX XXX
 * @returns string +614XXXXXXXX
 */
export const formatMobileNumberWithCountryCode = (mobileNumber) => {
  if (mobileNumber) {
    return mobileNumber.split(' ').join('').replace(/^04/, '+614');
  }
  return '';
};

/**
 *
 * @param {string} mobileNumber eg. 04XX XXX XXX
 * @returns string eg: 04XXXXXXXX
 */
export const formatNumberWithoutSpaces = (mobileNumber) => {
  if (mobileNumber) {
    return mobileNumber.replace(/\s/g, '');
  }
  return '';
};
